/**
 * @module systemManager
 */
import { device as defaultDevice } from "../../../web/manager/system/device";
import { device as hiDevice } from "./device";
import { application } from "./application";
import { network } from "./network";

const device = Object.assign(defaultDevice, hiDevice);
export const system = {
  device,
  application,
  network
};
